import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiZap, FiTarget, FiDownload, FiCheck } = FiIcons;

const Hero = () => {
  const features = [
    {
      icon: FiZap,
      title: "Ultra-simple",
      description: "no account, no forms."
    },
    {
      icon: FiTarget,
      title: "Actionable",
      description: "ranked savings + eligibility summary."
    },
    {
      icon: FiDownload,
      title: "Pitch-ready",
      description: "one-click PDF export."
    }
  ];

  return (
    <section className="relative bg-gradient-to-br from-primary-50 via-white to-primary-50 overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 bg-grid-slate-100 [mask-image:linear-gradient(0deg,white,rgba(255,255,255,0.6))] -z-10" />
      
      <div className="container-responsive section-spacing">
        <div className="text-center max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
              <span className="text-primary-600">Incentives,</span>{' '}
              <span className="bg-gradient-to-r from-primary-600 to-primary-800 bg-clip-text text-transparent">
                instantly.
              </span>
            </h1>
            
            <p className="text-xl sm:text-2xl text-gray-600 mb-8 text-balance">
              Upload your script or paste your film idea. We'll rank global tax 
              credits & rebates for you in seconds.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-8"
          >
            {features.map((feature, index) => (
              <div key={index} className="flex flex-col items-center text-center p-4">
                <div className="w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center mb-3">
                  <SafeIcon icon={feature.icon} className="w-6 h-6 text-primary-600" />
                </div>
                <h3 className="font-semibold text-gray-900 mb-1">{feature.title}</h3>
                <p className="text-sm text-gray-600">{feature.description}</p>
              </div>
            ))}
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="inline-flex items-center space-x-2 bg-primary-100 text-primary-800 px-4 py-2 rounded-full text-sm font-medium"
          >
            <SafeIcon icon={FiCheck} className="w-4 h-4" />
            <span>Free • BETA — Your feedback helps us improve</span>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;